import { render, staticRenderFns } from "./PerfumeBottle.vue?vue&type=template&id=5c765015&scoped=true"
import script from "./PerfumeBottle.vue?vue&type=script&lang=js"
export * from "./PerfumeBottle.vue?vue&type=script&lang=js"
import style0 from "./PerfumeBottle.vue?vue&type=style&index=0&id=5c765015&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c765015",
  null
  
)

export default component.exports